import { PRODUCT_CATEGORIES_BY_PERSON } from '@constants/filters';
import { useAppSelector } from '@store/hooks/redux';
import { IState } from '@store/reducers/productTags';
import { getActiveProductTags, getProductTags, getVisibleActiveProductCategory } from '@store/selectors/productTags';

export const useProductsTags = (): IState['list'] => useAppSelector(getProductTags);

export const useActiveProductTags = (): IState['list'][PRODUCT_CATEGORIES_BY_PERSON] =>
  useAppSelector(getActiveProductTags);

export const useVisibleActiveProductCategory = (): IState['activeCategory'] =>
  useAppSelector(getVisibleActiveProductCategory);
